import { Provider } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { environment } from '@environment';

export function provideApiConfiguration(): Provider {
  return {
    provide: ApiConfiguration,
    useFactory: () => {
      const config = new ApiConfiguration();
      config.rootUrl = environment.apiUrl;
      return config;
    }
  };
}
